export default function DualCTA() {
  return (
    <section className="w-full">
      <div className="flex flex-col md:flex-row">
        {/* Left Panel - Image driven */}
        <div className="relative md:w-1/2 min-h-[380px] md:min-h-[500px] overflow-hidden bg-secondary-100">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20artistic%20wide%20shot%20of%20organized%20product%20storage%20area%20with%20neatly%20labeled%20boxes%20and%20shelves%20in%20soft%20natural%20light%2C%20minimalist%20fulfillment%20center%20aesthetic%20with%20cream%20and%20warm%20beige%20color%20palette%2C%20clean%20modern%20warehouse%20photography%20with%20gentle%20shadows%20and%20orderly%20composition&width=960&height=800&seq=cta-left-sourcing-v2&orientation=landscape"
            alt="Curated product sourcing fulfillment center"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
          <div className="absolute top-8 left-8 md:top-10 md:left-10">
            <span className="inline-block px-3 py-1.5 bg-background-50/90 text-foreground-700 text-xs font-semibold tracking-wider uppercase rounded-md">
              Exclusive Access
            </span>
          </div>
          <div className="absolute bottom-8 left-8 md:bottom-12 md:left-10 right-8">
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-background-50 leading-none tracking-tight">
              Smarter
              <br />
              Sourcing
              <br />
              Starts Here
            </h2>
          </div>
        </div>

        {/* Right Panel - Text driven */}
        <div className="md:w-1/2 min-h-[380px] md:min-h-[500px] bg-background-50 flex items-center justify-center px-8 md:px-14 lg:px-20 py-14">
          <div className="text-center max-w-md">
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-950 leading-none tracking-tight">
              Compare Agents
              <br />
              <span className="text-accent-500">&amp; Save</span>
            </h2>
            <p className="mt-6 text-foreground-600 text-base leading-relaxed">
              The <strong>pandabuyspreadsheet</strong> system lets you compare multiple shopping agents side by side. Find the best rates, fastest shipping, and highest-rated service for your specific product categories — all in one structured view.
            </p>
            <div className="mt-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group whitespace-nowrap inline-flex items-center gap-2.5 px-9 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
              >
                Buy It Now
                <span className="transition-transform duration-300 group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}